import { atoms } from "@daangn/carotene/css";
import { vars } from "@daangn/carotene/vars";
import IconXmarkLine from "@karrotmarket/react-monochrome-icon/IconXmarkLine";
import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import type { HTMLAttributes } from "react";

import { Link } from "~/remix-lib";
import * as css from "./FormChip.css";

type FormChipBaseProps = {
  selected?: boolean;
};

type FormChipProps = React.HTMLAttributes<HTMLDivElement> & {
  asChild?: boolean;
} & FormChipBaseProps;
/**
 * @deprecated 디자인시스템 구현 전 임시 컴포넌트
 */
const FormChip = ({
  children,
  asChild = false,
  selected = false,
  ...otherProps
}: FormChipProps) => {
  const Comp = asChild ? Slot : "div";
  return (
    <Comp
      className={atoms({
        paddingX: 3,
        paddingY: 1.5,
        display: "inlineFlex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "full",
        borderColor: "decorative",
        borderWidth: 1,
        backgroundColor: selected ? "neutralInverted" : "layerDefault",
        color: selected ? "neutralInverted" : "neutral",
        cursor: "pointer",
      })}
      {...otherProps}
    >
      {children}
    </Comp>
  );
};

/**
 * @deprecated 디자인시스템 구현 전 임시 컴포넌트
 */
const FormChipAnchor = ({
  href,
  selected,
  children,
  closeIcon = false,
  className,
  ...otherProps
}: FormChipBaseProps & {
  closeIcon?: boolean;
  className?: string;
  href: string;
} & HTMLAttributes<HTMLAnchorElement>) => {
  return (
    <Link
      href={href}
      className={clsx(
        css.formChipBase,
        css.formChipVariant[selected ? "inverted" : "neutral"],
        className,
      )}
      {...otherProps}
    >
      {children}
      {closeIcon && (
        <IconXmarkLine
          size={14}
          color={vars.color.fg.neutralInverted}
          aria-hidden
        />
      )}
    </Link>
  );
};

export { FormChip, FormChipAnchor };
